export const measureUnitOptions = [
  {
    id: '1',
    label: 'Kilo neto',
    value: 'kg-n'
  },
  {
    id: '2',
    label: 'Kilo bruto',
    value: 'kg-b'
  },
  {
    id: '3',
    label: 'Cartones',
    value: 'cart'
  },
  {
    id: '4',
    label: 'Toneladas',
    value: 'ton'
  },
  {
    id: '5',
    label: 'Litros',
    value: 'lts'
  }
];
